<template>
  <div>
    <pt-form-item label="冻存位置:" labelWidth="90px" :required="true">
      <el-input v-model="form.frozenStorageLocation" name="labCode" v-validate="'required'" data-vv-as="冻存位置" placeholder="请输入冻存位置">
      </el-input>
    </pt-form-item>
  </div>
</template>

<script>
import {
  validate
} from 'utils/validate'
import {
  AdultNext
} from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '入库',
      form: {
        result: 'QUALIFIED',
        reason: '',
        expressNum: ''
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    next () {
      let data = {
        orderIds: [this.order.id],
        action: this.status
      }
      data.orderStatusDetail = {
        orderStatusResult: 'WAREHOUSING',
        frozenStorageLocation: this.form.frozenStorageLocation
      }
      return AdultNext.call(this, data)
    }
  },
  created () {

  }

}

</script>

<style lang="less">

</style>
